import { ProgressSpinnerExtraProperties, hideLoading, showLoading } from '../../components/wrappers/ProgressSpinner/store/ProgressSpinner';
import { store } from '../../index';

export const showProgressSpinner = (props?: ProgressSpinnerExtraProperties) => {
    store.dispatch(showLoading(props) as any)
}

export const hideProgressSpinner = (delay = 500, overrideKeepOpen = false) => {
    if (delay > 0) {
        setTimeout(() => {
            store.dispatch(hideLoading(overrideKeepOpen) as any);
        }, delay);
    }
    else {
        store.dispatch(hideLoading(overrideKeepOpen) as any);
    }
}